import { useHelpers } from 'context';

export const VirtualGamepadHelper = () => {
    useHelpers('mobileVirutalGamepad');

    return null;
};
